import React from "react";
import NameHeader from "../shared/NameHeader";
import { Dialog } from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../utilities/Constants";
import BackupViewData from "../../models/backupAndRestore/BackupViewData";
import backupAndRestoreListStore from "../../flux/stores/backupAndRestore/listStore";
import restoreBackupStore from "../../flux/stores/backupAndRestore/restoreBackupStore";
import deviceByGetAllStoreStore from "../../flux/stores/device/listBackupStore";
import backupAndRestoreActions from "../../flux/actions/BackupAndRestoreActions";
import AbbTableComponent from "../shared/AbbTableComponent";
import triggerNotifications from "../../utilities/TriggerNotifications";
import { NOTIFICATION_TIMEOUT } from "../../utilities/Constants";
import loadingActions from "../../flux/actions/LoadingActions";
import { Translation } from "react-i18next";

import History from "../../utilities/History";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingProps {
  backupPrefix?: any;
  isButtonDisabled?: boolean;
  clearPrefixInput?: (data: string) => void;
}

interface ILandingState {
  backupData: BackupViewData[];
  isRestoreBackup: boolean;
  selectedRowNo: number;
  deleteModalVisible: boolean;
  restoreModalVisible: boolean;
  selectedBackupForDelete: any[];
  disableButton: boolean;
  isRunningApiCall: boolean;
  isCreatingBackup: boolean;
}

export default class Landing extends React.Component<
  ILandingProps,
  ILandingState
> {
  private _mount: boolean = false;
  private _messages: string[];
  private _restoreData: any;
  private _restoreRowIndex: number;
  private _databaseName: any;

  constructor(props: {}) {
    super(props);
    this._mount = true;
    this.state = {
      backupData: [],
      isRestoreBackup: false,
      selectedRowNo: -1,
      deleteModalVisible: false,
      restoreModalVisible: false,
      selectedBackupForDelete: [],
      disableButton: false,
      isRunningApiCall: false,
      isCreatingBackup: false,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    backupAndRestoreListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({ backupData: state.data });
        this._messages = state.message;
      }
    });
    restoreBackupStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._messages = state.message;
      }
    });
    deviceByGetAllStoreStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({
          backupData: [...this.state.backupData, ...state.data],
        });
        this._messages = state.message;
      }
    });
    this.getAll();
  }

  private getAll() {
    loadingActions.setLoading(true);
    this.setState({ isRunningApiCall: true });
    ///Need to implement filter.
    let currentDate = ""; //moment(new Date()).format("YYYY-MM-DD");
    backupAndRestoreActions
      .getAll(currentDate)
      .then(() => {
        this.setState({ isRunningApiCall: false });
        loadingActions.setLoading(false);
      })
      .catch(() => {
        loadingActions.setLoading(false);
        this.setState({ isRunningApiCall: false });
      });
  }

  private onCreateBackup = () => {
    this.setState({ disableButton: true, isCreatingBackup: true });
    let prefix = String(this.props.backupPrefix);
    loadingActions.setLoading(true);
    backupAndRestoreActions
      .post(prefix)
      .then(() => {
        loadingActions.setLoading(false);
        setTimeout(() => {
          triggerNotifications.success(this._messages).then();
        }, NOTIFICATION_TIMEOUT);
        this.getAll();
        this.props.clearPrefixInput(CONSTANTS.LMS_BACKUP_PREFIX);
        this.setState({ disableButton: false, isCreatingBackup: false });
      })
      .catch((error: any) => {
        loadingActions.setLoading(false);
        triggerNotifications.errors(error.message, error.data).then();
        this.setState({ disableButton: false, isCreatingBackup: false });
      });
  };

  private onRestoreBackup = (data: any, rowIndex: number, dlg: any) => {
    let backupName = data.name;
    let service = data.service;
    let action = null;
    this.setState({ isRestoreBackup: true, selectedRowNo: rowIndex });
    action = backupAndRestoreActions;
    dlg.close();
    loadingActions.setLoading(true);
    action
      .restoreBackup(backupName)
      .then(() => {
        loadingActions.setLoading(false);
        setTimeout(() => {
          triggerNotifications.success(this._messages).then();
        }, NOTIFICATION_TIMEOUT);
        this.setState({ isRestoreBackup: false, selectedRowNo: -1 });
      })
      .catch((error: any) => {
        loadingActions.setLoading(false);
        this.setState({ isRestoreBackup: false, selectedRowNo: -1 });
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private openDialog = (data: any) => {
    this.setState({ selectedBackupForDelete: data, deleteModalVisible: true });
  };

  private openRestoreDialog = (data: any, rowIndex: number) => {
    this._restoreData = data;
    this._restoreRowIndex = rowIndex;
    this._databaseName = data.name;
    this.setState({ restoreModalVisible: true });
  };

  private onDeleteBackup = () => {
    let backupName = [];
    this.setState({ deleteModalVisible: false });
    backupName = this.state.selectedBackupForDelete.map((d: any) => d.name);
    loadingActions.setLoading(true);
    backupAndRestoreActions
      .deleteBackup(backupName)
      .then(() => {
        loadingActions.setLoading(false);
        triggerNotifications.success(this._messages).then();
        this.disableCreateButton(false);
        this.getAll();
        this.setState({ selectedBackupForDelete: [] });
      })
      .catch((error: any) => {
        loadingActions.setLoading(false);
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private onPauseRestore = (data: any, rowIndex: number) => {
  };

  private onCancelRestore = (data: any, rowIndex: number) => {
  };
  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };

  public disableCreateButton = (value: boolean) => {
    this.setState({
      disableButton: value
    })
  }
  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout" style={{ marginLeft: "-6px" }}>
            {renderBreadcrumb(
              [
                { text: t("Home"), link: "/samplenew", bolder: false },
                { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                { text: t(CONSTANTS.MODULE_BACKUP_AND_RESTORE), link: null, bolder: true }
              ], "padding-backup-restore pb-3")
            }
            <NameHeader
              authKey={CONSTANTS.AUTHKEY_BACKUP_RESTORE}
              isShowBackup={true}
              data={""}
              onCreateBackup={this.onCreateBackup}
              isCreatingBackup={this.state.isCreatingBackup}
              isButtonDisabled={
                this.props.isButtonDisabled || this.state.disableButton
              }
              isDelete={
                this.state.backupData && this.state.backupData.length
                  ? false
                  : true
              }
              isMoreEnable={true}
            />

            {this.state.backupData.length === 0 ? (
              <div className="onboarding-backup p-4 mt-3">
                <div className="p-5 onboarding-folder-backup">
                  {this.state.isRunningApiCall ? (
                    <p className="title">{t(CONSTANTS.WAITFOR_DATA_MESSAGE)}</p>
                  ) : (
                    <p className="title">
                      {t(CONSTANTS.NO_BACKUP_DATA_MESSAGE)}
                    </p>
                  )}
                </div>
              </div>
            ) : (
              <div className="summary-layout mt-3">
                <AbbTableComponent
                authKey={CONSTANTS.AUTHKEY_BACKUP_RESTORE}
                  columns={[
                    {
                      dataField: "checkbox",
                      text: "",
                    },
                    {
                      dataField: "name",
                      text: t(CONSTANTS.LABEL_BACKUP_NAME),
                    },
                    {
                      dataField: "size",
                      text: t(CONSTANTS.LABEL_BACKUP_SIZE),
                    },
                    {
                      dataField: "date",
                      text: t(CONSTANTS.LABEL_BACKUP_DATE),
                    },
                    {
                      dataField: "time",
                      text: t(CONSTANTS.LABEL_BACKUP_TIME),
                    },
                    {
                      dataField: "status",
                      text: t(CONSTANTS.LABEL_BACKUP_STATUS),
                    },
                    {
                      dataField: "restore",
                      text: "",
                    },
                  ]}
                  list={this.state.backupData}
                  select={false}
                  isFixedColumn={false}
                  isEditable={false}
                  delete={false}
                  onRestoreBackup={this.openRestoreDialog}
                  onPauseRestore={this.onPauseRestore}
                  onCancelRestore={this.onCancelRestore}
                  name={CONSTANTS.LABEL_BACKUP_SUMMARY}
                  moduleName={CONSTANTS.LABEL_BACKUP_SUMMARY}
                  redirectBaseUrl={CONSTANTS.MODULE_BACKUP_AND_RESTORE}
                  isRestoreBackup={this.state.isRestoreBackup}
                  selectedRowNo={this.state.selectedRowNo}
                  onDeleteBackup={this.openDialog}
                  isDeleteAction={true}
                  selectedRowForDelete={this.state.selectedBackupForDelete}
                  isTitle={
                    <div className="float-left ml-2">
                      <p className="sidebar-main-title font-weight-bold">
                        {t(CONSTANTS.LABEL_BACKUP_SUMMARY)}
                      </p>
                    </div>
                  }
                  disableCreateButton={this.disableCreateButton}
                />
              </div>
            )}
            <Dialog
              isOpen={this.state.deleteModalVisible}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ deleteModalVisible: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.DELETE_TITLE, {
                name: t(CONSTANTS.BUTTON_CONFIRM),
              })}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.onDeleteBackup,
                },
              ]}
            >
              <div>
                {t(CONSTANTS.DELETE_ALL_MESSAGE) +
                  "(" +
                  this.state.selectedBackupForDelete.length +
                  ") Backup file(s) ?"}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.DELETE_POPUP_MESSAGE)}
              </div>
            </Dialog>
            <Dialog
              isOpen={this.state.restoreModalVisible}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ restoreModalVisible: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.RESTORE_TITLE)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: (dlg) =>
                    this.onRestoreBackup(
                      this._restoreData,
                      this._restoreRowIndex,
                      dlg
                    ),
                },
              ]}
            >
              <div>
                {t(CONSTANTS.RESTORE_MESSAGE)} {this._databaseName} ?
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.RESTORE_NOTE_MESSAGE)}{" "}
                {this._databaseName}
              </div>
            </Dialog>
          </div>
        )}
      </Translation>
    );
  }
}
